import React from 'react';
import './Footer.css';

import { Logo, Newsletter } from '../../components'; // Importing the Logo and Newsletter components
import { contactContent } from '../../constants'; // Importing contact information and services data

// Importing necessary icons from react-icons
import { FaFacebookF, FaInstagram, FaLinkedin } from 'react-icons/fa';
import { FaShirt, FaXTwitter } from "react-icons/fa6";

// Importing Link for navigation
import { Link } from 'react-router-dom';



const Footer = () => {

  return (
    <footer className='footer'>

      <div className='box-container'>

        {/* About Section */}
        <div className='footer-item'>

          <Logo /> {/* Display the Logo component */}
          <p>Your Trusted Partner for Clean and Fresh Fabrics. Providing Quality Laundry and Dry Cleaning Services to Enhance Your Wardrobe.</p> {/* Description for the about section */}

          {/* Social media icons with links */}
          <div className='social'>
            <a href="/#"><FaFacebookF className='icon' /></a>
            <a href="/#"><FaXTwitter className='icon' /></a>
            <a href="/#"><FaInstagram className='icon' /></a>
            <a href="/#"><FaLinkedin className='icon' /></a>
          </div>

        </div>

        {/* Contact Info Section */}
        <div className='footer-item'> 

          <h2>Contact Info</h2>

          <div className='info connect'>
            {contactContent
              .filter(contact => contact.id !== 4) // Exclude the contact with id: 4
              .map((contact) => {
                return (
                  <div key={contact.id}>
                    {contact.content.map((item, index) => (
                      <div key={index} className='connect-item'>
                        <div className='icon'>{contact.icon}</div>
                        <span>{item}</span>
                      </div>
                    ))}
                  </div>
                );
              })
            }
          </div>

        </div>

        {/* Useful Links Section */}
        <div className='footer-item'>

          <h2>Quick Links</h2>

          {/* Links for easy navigation to various pages */}
          <div className='info links'> 
            <p><FaShirt className='icon' /><Link to='/About-us'>about Us</Link></p>
            <p><FaShirt className='icon' /><Link to='/Pricing'>Pricing</Link></p>
            <p><FaShirt className='icon' /><Link to='/Services'>Services</Link></p>
            <p><FaShirt className='icon' /><Link to='/Projects'>Projects</Link></p>
            <p><FaShirt className='icon' /><Link to='/Blog-grid'>Blogs</Link></p>
            <p><FaShirt className='icon' /><Link to='/Contact-us'>contact</Link></p>
          </div>

        </div>

        {/* Newsletter Section */}
        <div className='footer-item'>

          <h2>Newsletter</h2>
          <p>Stay connected for the latest updates on special promotions and tips for maintaining your garments.</p> {/* Description for the Newsletter section */}

          {/* Newsletter component to subscribe */}
          <Newsletter variant='dark' idPrefix='2' />

        </div>

      </div>

      <div className='content'>

        {/* Footer content with copyright information */}
        <p>&copy; Sparkle 2025 All Rights Reserved</p>

      </div>

    </footer>
  )
}

export default Footer;